import { RotateCw, TriangleAlert, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * LA DOMANDA NON E' PARTITA: LO SI DICE, E IL TESTO NON SI PERDE (05/10/2026).
 *
 * Audit del 04/10: senza rete la chat non diceva niente (il tasto sembrava
 * rotto), e se la rete cadeva a meta' la domanda spariva dal campo e restava
 * una finta risposta «problema temporaneo». L'installatore lavora in cantine e
 * locali tecnici senza campo: e' il caso normale. Ora sopra il campo compare
 * questo avviso, il testo torna nel campo e «Riprova» lo rimanda com'e'.
 * Tono di avviso (giallo al 15%, DESIGN.md «toni di stato»), mai solo colore:
 * icona e parole.
 */
export type MotivoInvioFallito = "rete" | "motore" | "lunga";

interface Props {
  motivo: MotivoInvioFallito;
  messaggio: string;
  onRiprova?: () => void;
  occupato?: boolean;
}

export function AvvisoInvio({ motivo, messaggio, onRiprova, occupato }: Props) {
  const Icona = motivo === "rete" ? WifiOff : TriangleAlert;
  return (
    <div
      role="alert"
      className="mx-auto mb-2 w-full max-w-3xl px-3 sm:px-5"
    >
      <div className="flex items-center gap-3 rounded-2xl border border-[hsl(var(--warning)/0.45)] bg-[hsl(var(--warning)/0.15)] py-2 pl-3 pr-2">
        <Icona className="h-5 w-5 shrink-0 text-warning" aria-hidden="true" />
        <p className="min-w-0 flex-1 text-sm leading-snug text-foreground">{messaggio}</p>
        {onRiprova && (
          <Button
            type="button"
            variant="outline"
            onClick={onRiprova}
            disabled={occupato}
            className="h-11 shrink-0 gap-1.5 rounded-xl border-[hsl(var(--warning)/0.6)] bg-transparent px-4 text-sm font-semibold text-foreground hover:bg-[hsl(var(--warning)/0.2)]"
          >
            <RotateCw className="h-4 w-4" aria-hidden="true" />
            Riprova
          </Button>
        )}
      </div>
    </div>
  );
}
